import {
  AnagraficaDelegatoDTO,
  GetFrontAnagraficheDelegatiParams,
  useDeleteFrontAnagraficheDelegatiId,
  useGetFrontAnagraficheDelegati,
} from '@framework/api-client';
import {
  ColumnSortDirections,
  getPagination,
  handlePaginationChange,
  useHistory,
  usePaginationUrlQueryState,
} from '@framework/ui';
import { isEqual, omit } from 'lodash';
import { useMemo } from 'react';
import { addressBookColumns } from './addressBookColumns';

/**
 * Hook centralizzato per la gestione dell'anagrafica delegati
 */
export function useAddressBook() {
  const history = useHistory();

  const defaultQuery = useMemo(
    () =>
      getPagination({
        page: 0,
        pageSize: 10,
        sort: 'cognome',
        direction: ColumnSortDirections.descend,
      }),
    [],
  );

  const [query, setQuery] =
    usePaginationUrlQueryState<GetFrontAnagraficheDelegatiParams>({
      history,
      input: defaultQuery,
    });

  const { data, error, isLoading, isFetching } = useGetFrontAnagraficheDelegati(
    query,
    {
      query: {
        keepPreviousData: true,
      },
    },
  );

  const deleteMutation = useDeleteFrontAnagraficheDelegatiId();

  const isFiltered = useMemo(() => {
    if (isFetching) return false;
    return !isEqual(
      omit(query, ['pagina', 'ordinamenti', 'limite']),
      omit(defaultQuery, ['pagina', 'ordinamenti', 'limite']),
    );
  }, [isFetching, query, defaultQuery]);

  const { records, meta } = useMemo(
    () => ({ records: data?.dati ?? [], meta: data?.meta }),
    [data],
  );

  const onPaginationChange = handlePaginationChange<
    AnagraficaDelegatoDTO,
    GetFrontAnagraficheDelegatiParams
  >({
    columns: addressBookColumns,
    defaultQuery,
    query,
    setQuery,
  });

  return {
    defaultQuery,
    query,
    setQuery,
    records,
    meta,
    isLoading,
    isFetching,
    isFiltered,
    error,
    deleteMutation,
    onPaginationChange,
  };
}
